export const getDefaultDescription = () => {
  return {
    type: 'doc',
    content: [{ type: 'paragraph', content: null }],
  };
};

